module.exports = __webpack_public_path__ + "static/media/Avatars_Male-05.a7462bd9.png";